import qs from "qs";
import http from "../../h5-network/request.js";
let query = qs.parse(location.search.slice(1));
let token = "";
let memberId = "";
const source = "MINI_PROGRAM";
export default {
    param() {
        let member = sessionStorage.getItem(
            `INVERTADVISER_WX_MEMBER_${query.userCode || query.unionid}`
        );
        member && (member = JSON.parse(member));
        return {
            source,
            token: token || member?.token,
            userCode: "",
            memberId: memberId || member?.memberId,
            ...query,
        };
    },
    linkSearch(param) {
        return `${qs.stringify({ ...this.param(), ...param })}`;
    },
    async isLogin() {
        //wechatUser 判断是否绑定微信 绑定:返回登录态
        const build = await http({
            loading: true,
            url: "/bdzb-permission/usr/wechatUser",
            data: {},
            method: "POST",
            dialog: true,
        }).then(
            (data) => {
                if (data) {
                    data.token && (token = data.token);
                    data.memberId && (memberId = data.memberId);
                    //  openid member_third_token 兼容老北斗金牛
                    if (query.openid) {
                        window.sessionStorage.setItem("openid", query.openid);
                    }
                    window.localStorage.setItem(
                        "member_third_token",
                        JSON.stringify(data)
                    );
                }
                return data;
            },
            () => false
        );

        if (build) {
            return Promise.resolve(true);
        } else {
            return Promise.reject(false);
        }
    },
    goToLogin() {
        http({
            loading: true,
            url: "/bdzb-permission/usr/getMobileByUserCode",
            data: {},
            method: "POST",
        }).then((data) => {
            let str = data ? `&mobile=${data}` : "";
            location.hash =
                `#/wx-login?saveKey=${query.userCode ||
                    query.unionid}&from=${location.hash.replace("#/", "")}` +
                str;
        });
    },
};
